import { Component, Input, Output, EventEmitter } from '@angular/core';
import { PostEntity } from 'src/app/models/post.model';

@Component({
  selector: 'app-blogleftsidebar',
  templateUrl: './blogleftsidebar.component.html',
  styleUrls: ['./blogleftsidebar.component.css'],
})
export class BlogleftsidebarComponent {
  @Input() posts: PostEntity[] = [];
  @Input() selectedTag: string | null = null;
  @Output() tagSelected = new EventEmitter<string | null>();

  get popularPosts(): PostEntity[] {
    return this.posts.slice(0, 4);
  }

  get allTags(): string[] {
    const tagSet = new Set<string>();
    this.posts.forEach((post) => {
      if (post.topics && Array.isArray(post.topics)) {
        post.topics.forEach((tag) => {
          if (tag && tag.trim()) {
            tagSet.add(tag.trim());
          }
        });
      }
    });
    return Array.from(tagSet).sort();
  }

  onTagClick(tag: string, event: Event): void {
    event.preventDefault();
    const tagToFilter = this.selectedTag === tag ? null : tag;
    this.tagSelected.emit(tagToFilter);
  }

  isTagSelected(tag: string): boolean {
    return this.selectedTag === tag;
  }
}
